import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { MiniatureMessage } from 'APP/main/ChatView/components/MiniatureMessage/MiniatureMessage';
import { ChatMessage } from 'STORE/Messages/Message/ChatMessage/ChatMessage';

import { useRepliedMessagePresenter } from './RepliedMessage.presenter';
import styles from './RepliedMessage.styles.m.css';

export type TRepliedMessageTheme = '1' | '2';

interface IRepliedMessageProps {
  message: ChatMessage;
  className?: string;
  preventInteraction?: boolean;
  theme?: TRepliedMessageTheme;
}

export const RepliedMessage: FC<IRepliedMessageProps> = observer(
  ({ message, className, preventInteraction, theme = '1' }) => {
    const presenter = useRepliedMessagePresenter(message);

    if (!presenter.message) {
      return null;
    }

    return (
      <div
        className={classNames(styles.container, styles[`theme-${theme}`], className)}
        data-test="reply-message"
      >
        <div className={styles.content}>
          <MiniatureMessage
            preventInteraction={preventInteraction}
            message={message}
            titleClassName={styles.title}
            textClassName={styles.text}
            iconClassName={styles.icon}
            title={<p className={styles.title}>{presenter.title}</p>}
          />
        </div>
      </div>
    );
  }
);
